import {
  Person,
  VerifiedUser,
  Note,
  Flag,
  SafetyCheck,
  Assignment,
  List as ListIcon,
  DoneOutline,
  Report,
  Lock,
  EditNote,
  Speed,
} from '@mui/icons-material';
import React from 'react';
import {useRTQ} from '../../hooks/useRTQ';
import {HandoverStepType} from './HandoverStepTypes';

export const useStepsToInfo = (): Record<
  HandoverStepType,
  {icon: React.ReactNode; title: string}
> => {
  const {vulnerabilityName} = useRTQ();
  return {
    meeting: {icon: <Person />, title: 'Meeting'},
    resilience: {icon: <VerifiedUser />, title: vulnerabilityName},
    notes: {icon: <Note data-testid="NotesIcon" />, title: 'Notes'},
    goals: {icon: <Flag data-testid="GoalsIcon" />, title: 'Goals'},
    risk: {icon: <SafetyCheck />, title: 'Risk'},
    risknotes: {icon: <Speed />, title: 'Risk'},
    requirements: {icon: <Assignment />, title: 'Requirements'},
    'requirements-builder': {icon: <Lock />, title: 'Requirements'},
    tasks: {icon: <ListIcon data-testid="TasksIcon" />, title: 'Tasks'},
    summary: {icon: <DoneOutline data-testid="SummaryIcon" />, title: 'Summary'},
    report: {icon: <Report data-testid="ReportIcon" />, title: 'Report'},
  };
};
